require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-statements-temporarily-unavailable.json") })
        }
      }, "path---articles-statements-temporarily-unavailable");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-statements-temporarily-unavailable!./.cache/json/articles-statements-temporarily-unavailable.json
// module id = 1736
// module chunks = 231608221292675